import { render, staticRenderFns } from "./PollutionPrevention.vue?vue&type=template&id=29b5d580&scoped=true&"
import script from "./PollutionPrevention.vue?vue&type=script&lang=js&"
export * from "./PollutionPrevention.vue?vue&type=script&lang=js&"
import style0 from "./PollutionPrevention.vue?vue&type=style&index=0&id=29b5d580&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b5d580",
  null
  
)

export default component.exports